/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Templates_Or_ScratchInputs */



/**
* | output |
* | --- |
* | "or start from scratch" |
*
* @param {Agent_Templates_Or_ScratchInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_templates_or_scratch = /** @type {((inputs?: Agent_Templates_Or_ScratchInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Templates_Or_ScratchInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("oder ohne Vorlage beginnen")
	return /** @type {LocalizedString} */ ("or start from scratch")
});